// Curated synonym groups for "what it's used for" medication search (dashboard
// quick-log picker, MEDICATION_QUICK_LOG). Search-time only — never changes what's
// stored on a regimen item's free-text `intendedFor` field. Lets a query like
// "reflux" also surface a medication tagged "heartburn" or "GERD", and vice versa.
const SYNONYM_GROUPS: string[][] = [
  ["reflux", "acid reflux", "heartburn", "gerd", "acid", "indigestion"],
  ["allergy", "allergies", "hay fever", "antihistamine"],
  ["blood pressure", "hypertension", "bp"],
  ["pain", "ache", "analgesic", "painkiller"],
  ["headache", "migraine"],
  ["cholesterol", "statin", "lipid"],
  ["diabetes", "blood sugar", "glucose"],
  ["anxiety", "depression", "mood", "antidepressant"],
  ["sleep", "insomnia"],
  ["nausea", "anti-nausea", "vomiting"],
  ["cough", "cold", "congestion", "decongestant"],
  ["thyroid", "hypothyroid"],
  ["asthma", "inhaler", "respiratory", "breathing"],
];

function expand(term: string): Set<string> {
  const q = term.toLowerCase().trim();
  const out = new Set<string>();
  if (!q) return out;
  out.add(q);
  for (const group of SYNONYM_GROUPS) {
    if (group.some((g) => g.includes(q) || q.includes(g))) {
      for (const g of group) out.add(g);
    }
  }
  return out;
}

/**
 * True if `query` matches a medication's `name` or its free-text `intendedFor`
 * (which may list several uses separated by commas/semicolons), via substring or
 * curated synonym expansion in either direction.
 */
export function matchesMedicationSearch(query: string, name: string, intendedFor?: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  if (name.toLowerCase().includes(q)) return true;
  if (!intendedFor) return false;

  const fragments = intendedFor.split(/[,;]/).map((f) => f.trim().toLowerCase()).filter(Boolean);
  if (!fragments.length) return false;

  const queryTerms = expand(q);
  for (const frag of fragments) {
    for (const qt of queryTerms) {
      if (frag.includes(qt) || qt.includes(frag)) return true;
    }
  }
  return false;
}
